import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const PreventBackNavigation = () => {
  const location = useLocation();

  useEffect(() => {
    const handlePopState = () => {
      window.history.pushState(null, "", window.location.pathname);
    };

    window.history.pushState(null, "", location.pathname);
    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [location]);

  return null;
};

export default PreventBackNavigation;
